import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ContentWithCardLoading } from "../../../../components/loading";
import ContentWrapper from "../../../Wrapper";
import AccountDetailsSubheader from "../../components/account-details-subheader";
import { getAccountSettingsRequest, updateAccountSettingsRequest, getAdminAccountSettingsRequest, updateAdminAccountSettingsRequest } from "../../store/actions/account_settings_actions";

export default function AccountSettings({ match }) {
    const [cutOff, setCutOff] = useState(0);
    const [shortLinkAccess, setShortLinkAccess] = useState(false);

    const tabName = "Settongs";

    const settingsStore = useSelector((state) => state.accounts.settings);

    const dispatch = useDispatch();

    useEffect(() => {
        if (match.params.accountId) {
            dispatch(getAccountSettingsRequest({ accountId: match.params.accountId }));
            dispatch(getAdminAccountSettingsRequest({ accountId: match.params.accountId }));
        }
    }, [dispatch, match.params.accountId]);

    useEffect(() => {
        if (settingsStore.data && settingsStore.data.cmgnCutOff) setCutOff(settingsStore.data.cmgnCutOff)
        else setCutOff(0)
    }, [settingsStore.data]);

    useEffect(() => {
        if (settingsStore.adminData && settingsStore.adminData.shortLinkEnabled) setShortLinkAccess(settingsStore.adminData.shortLinkEnabled)
        else setShortLinkAccess(false)
    }, [settingsStore.adminData]);

    const handleUpdate = () => {
        dispatch(updateAccountSettingsRequest({ accountId: match.params.accountId, cmgnCutOff: cutOff }))
    }

    const handleAdminUpdate = () => {
        dispatch(updateAdminAccountSettingsRequest({ accountId: match.params.accountId, data: { shortLinkEnabled: shortLinkAccess } }))
    }

    return (
        <ContentWrapper subHeader={<AccountDetailsSubheader active={tabName} />}>
            {settingsStore.loading || settingsStore.adminLoading ? (
                <ContentWithCardLoading />
            ) : (
                <React.Fragment>
                    <div className={`card card-custom mb-8`}>
                        <div className="card-body py-3 px-3 h-100 w-100" style={{ padding: 15 }}>
                            <Form>
                                <Form.Group>
                                    <Form.Label>SMS Campaign Cut Off</Form.Label>
                                    <Form.Control type="number" value={cutOff} onChange={e => setCutOff(e.target.value)} />
                                </Form.Group>
                                <Form.Group>
                                    <Button size="sm" onClick={handleUpdate}>Update</Button>
                                </Form.Group>
                            </Form>
                        </div>

                    </div>
                    <div className={`card card-custom`}>
                        <div className="card-body py-3 px-3 h-100 w-100" style={{ padding: 15 }}>
                            <Form>
                                <Form.Group>
                                    <Form.Label>Short Link Access</Form.Label>
                                    <Form.Check
                                        type="switch"
                                        id="short-link"
                                        label="Short Link Access"
                                        checked={shortLinkAccess}
                                        onChange={e => setShortLinkAccess(e.target.checked)}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <Button size="sm" onClick={handleAdminUpdate}>Update</Button>
                                </Form.Group>
                            </Form>
                        </div>

                    </div>
                </React.Fragment>
            )}
        </ContentWrapper>
    );
}